import {I18n} from '../I18n/components/offer';

const offerValidator = lang => {
    return {
        title: {
            rules: [
                {
                    test: /^[-_.a-zA-Z0-9]+$/,
                    message: I18n[lang].titleValidationRules,
                },
            ],
            errors: [],
            valid: false,
            state: '',
        },
        icon: {
            rules: [
                {
                    test: (value) => {
                        if (value)
                            return value.size <= 100000 //100KB
                        else
                            return true;
                    },
                    message: I18n[lang].iconIsTooBig,
                },
            ],
            errors: [],
            valid: true,
            state: '',
        },
        reward: {
            rules: [
                {
                    test: (value) => {
                        return value >= 0.1
                    },
                    message: I18n[lang].canNotBeNull,
                },
            ],
            errors: [],
            valid: false,
            state: '',
        },
        rewardLimit: {
            rules: [
                {
                    test: (value) => {
                        return true//value >= 1
                    },
                    message: 'Can not be null',
                },
            ],
            errors: [],
            valid: false,
            state: '',
        },
        startDate: {
            rules: [
                {
                    test: (value) => {
                        return true//value.length >= 1
                    },
                    message: 'Can not be null',
                },
            ],
            errors: [],
            valid: false,
            state: '',
        },
        endDate: {
            rules: [
                {
                    test: (value) => {
                        return true//value && value.length >= 1
                    },
                    message: 'Can not be null',
                },
            ],
            errors: [],
            valid: false,
            state: '',
        },
    }
};

export default offerValidator;



// WEBPACK FOOTER //
// ./src/helpers/offerValidator.js